import { Component, OnDestroy } from '@angular/core';

@Component({
  template: '',
})
export class BaseService implements OnDestroy {
  ngOnDestroy() {}
}
